var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[(_vm.hasAdminMenu)?_c('AdminHeader'):_vm._e(),(_vm.hasHeader)?_c('Header'):_vm._e(),_c('span',{style:(`display:block; height:${_vm.topHeaderSpace}px;`),attrs:{"id":"topNavSpacer"}}),_c('Sidebar'),_c('router-view')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }